import { Link } from "react-router-dom";

export default function AdminFooter() {
  return (
    <footer className="border-t border-background-200 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-foreground-500">
        <p>© 2026 Rythugaru Agri Tourism. All rights reserved.</p>

        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
          <Link to="/privacy" className="hover:text-foreground-900 transition-colors cursor-pointer">
            Privacy
          </Link>
          <Link to="/terms" className="hover:text-foreground-900 transition-colors cursor-pointer">
            Terms
          </Link>
          <Link to="/admin/help" className="hover:text-foreground-900 transition-colors cursor-pointer">
            Help
          </Link>
          <span className="inline-flex items-center gap-1.5">
            <span className="w-1.5 h-1.5 rounded-full bg-secondary-500"></span>
            System Status: Operational
          </span>
          <span className="text-foreground-400">Version 1.0.0</span>
        </div>
      </div>
    </footer>
  );
}